// Dashboard Users onboarding page translations (pt-BR), loaded into dashboard.users.onboarding by ../pt-BR.users.js
module.exports = {
  menu: "Funil de Onboarding",
  title: "Funil de Onboarding",
  description: "Onde a plataforma está a perder utilizadores, etapa a etapa.",
  kpis: {
    installs: "Instalações",
    conversion: "Conversão total",
    worstDrop: "Maior queda",
    timeToFirstEvent: "Tempo até ao 1.º evento",
  },
  info: {
    installs: "Vezes que a app foi aberta pela primeira vez depois de instalada; não se liga às contas, por isso fica fora do funil.\nFonte: Google Analytics (evento first_open).",
    conversion: "Contas criadas no período que chegaram ao último passo do funil (voltaram no dia seguinte).\nFonte: Firebase (perfis, eventos e registo de atividade).",
    worstDrop: "Passo do funil onde se perdem mais contas, em pontos percentuais face ao passo anterior.\nFonte: Firebase (as mesmas contagens do funil).",
    timeToFirstEvent: "Mediana de dias entre a criação da conta e o primeiro evento criado.\nFonte: Firebase (primeiro evento de cada criador).",
  },
  units: {
    days: "dias",
  },
  hints: {
    noInstalls: "sem dados do Google Analytics",
    conversion: "{from} → {to}",
    median: "mediana",
  },
  base: {
    accounts: "contas criadas",
    installs: "instalações",
  },
  steps: {
    created: "Criou conta",
    confirmed: "Confirmou cadastro",
    photo: "Adicionou foto",
    bio: "Criou biografia",
    joined: "Entrou num evento",
    createdEvent: "Criou um evento",
    returned: "Voltou no dia seguinte",
  },
  panels: {
    funnel: {
      title: "Funil de onboarding — {base} do período",
      note: "Cada etapa conta as contas criadas no período que a cumpriram, mesmo sem cumprir a anterior. \"Voltou no dia seguinte\" só conta as contas criadas até {date}: as do último dia do período, ou de hoje, ainda não têm um dia seguinte.",
      noteNoReturn: "Cada etapa conta as contas criadas no período que a cumpriram, mesmo sem cumprir a anterior. \"Voltou no dia seguinte\" ainda não tem dados: as contas criadas no período ainda não têm um dia seguinte.",
    },
    conversion: "Conversão total por {gran}",
    conversionNote: "Quando há menos de {min} contas criadas por {gran}, a conversão junta os períodos anteriores até chegar a esse número.",
    loss: "Perda por etapa (pontos percentuais)",
  },
  panelInfo: {
    funnel: "Contas criadas no período que cumpriram cada etapa.\nFonte: Firebase (perfis, contas, eventos e registo de atividade).",
    conversion: "Contas criadas que chegaram à última etapa, em cada intervalo.\nFonte: Firebase (perfis, contas, eventos e registo de atividade).",
    loss: "Pontos percentuais perdidos de cada etapa para a seguinte.\nFonte: Firebase (perfis, contas, eventos e registo de atividade).",
  },
};
